import moment from 'moment';

type RadioOption = {
  id: string;
  name: string;
  value: string;
};

export const HOW_TO_PROCEED_OPTIONS: RadioOption[] = [
  {
    id: 'clear',
    name: 'Clear - stuck users will exit the workflow',
    value: 'clear',
  },
  {
    id: 'proceed',
    name: 'Proceed - stuck users will continue where they left off. Filter on trigger event data fields, and any downstream steps/emails/etc will NOT HAVE ACCESS to the triggering event data',
    value: 'proceed',
  },
];

export const WHEN_TO_PROCEED_OPTIONS: RadioOption[] = [
  {
    id: 'only-if-safe',
    name: 'Only if safe - proceed only if the workflow is a recurring triggered workflow, or if the rest of the workflow doesn’t use triggering data anywhere',
    value: 'only-if-safe',
  },
  {
    id: 'regardless',
    name: 'Proceed regardless - Filter on trigger event data fields, and any downstream steps/emails/etc will NOT HAVE ACCESS to the triggering event data',
    value: 'regardless',
  },
];

const getDefaultOption = (opts: RadioOption[]) => opts[0].value;
export const HOW_DEFAULT_OPTION = getDefaultOption(HOW_TO_PROCEED_OPTIONS);
export const WHEN_DEFAULT_OPTION = getDefaultOption(WHEN_TO_PROCEED_OPTIONS);

const formattedDate = moment().format('yyyyMMDD');
const formattedTime = moment().format('HHmmss');
export const DATE_TIME = `${formattedDate}${formattedTime}`;
